module.exports = __webpack_public_path__ + "static/media/what-you-not-got-in-there.0ea11f02.txt";